import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { GlobalState } from "./app/store/rootReducer";
import { createBrowserHistory } from "history";

import {
  IMyzTokenUserRequest,
  myzTokenUserRequest,
} from "./app/store/MyzTokenUser/actions";

import * as Components from "@zanichelli/myz-react-utils";
import Alert from "./app/views/Alert";

import Router from "./app/routing/Router";
import Redirector from "./app/routing/Redirector";

import { API } from "./beans";

import { Wrap } from "./App.style";

import "./i18n";
import { ZSkipToContent } from "@zanichelli/albe-web-components/react";

const history = createBrowserHistory();

type Props = {
  userData: API.MyzTokenUser | null;
  myzTokenUserRequest: () => IMyzTokenUserRequest;
};
type State = {
  location: null | string;
};

class App extends React.Component<Props, State> {
  public readonly state: State = {
    location: window.location.pathname,
  };

  componentDidMount() {
    history.listen((l: any, a: any): void => {
      // INFO: debug router
      console.groupCollapsed("HISTORY");
      console.log("location: ", l);
      console.log("action: ", a);
      console.groupEnd();

      this.setState({ location: l.pathname });
    });

    this.props.myzTokenUserRequest();
  }

  renderTopbar() {
    return <Components.Topder showMyzLink={true} />;
  }

  renderFooter() {
    return <Components.Footer />;
  }

  render() {
    const { location } = this.state;
    return (
      <Wrap className="App">
        <ZSkipToContent
          links={[
            {
              label: "Vai al contenuto principale",
              href: `${location}#skip-to-main`,
            },
            { label: "Vai al footer", href: `${location}#zanichelli-footer` },
          ]}
        />
        {this.renderTopbar()}
        <Alert />
        <div className="content">
          <div id="skip-to-main">
            <Router history={history} />
            <Redirector history={history} />
          </div>
        </div>
        <div id="zanichelli-footer">{this.renderFooter()}</div>
      </Wrap>
    );
  }
}

function mapStateToProps(state: GlobalState) {
  return {
    userData: state.myztokenuser.data,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    myzTokenUserRequest: () => dispatch(myzTokenUserRequest()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
